export default __webpack_public_path__ + "static/media/pragmatic.19ee8ccb.png";